import { useNavigate } from 'react-router-dom';
import { NotesList } from '../components/notes/NotesList';
import {
  DocumentTextIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';

export default function NotesPage() {
  const navigate = useNavigate();

  const handleSelectNote = (bookingId: number) => {
    navigate(`/sessions/${bookingId}/notes`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <DocumentTextIcon className="h-8 w-8 text-blue-600" />
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Session Notes</h1>
                <p className="text-sm text-gray-600">
                  Confidential notes from your therapy sessions
                </p>
              </div>
            </div>

            {/* E2E Encryption Badge */}
            <div className="flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-lg">
              <ShieldCheckIcon className="h-5 w-5 text-green-600" />
              <div className="text-left">
                <p className="text-sm font-medium text-green-700">
                  End-to-end encrypted
                </p>
                <p className="text-xs text-green-600">
                  Only you can read these notes
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="p-6">
            <NotesList onSelectNote={handleSelectNote} />
          </div>
        </div>

        {/* Info Section */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-sm font-semibold text-blue-900 mb-2">
            About End-to-End Encryption
          </h3>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• Your session notes are encrypted on your device before being sent to our servers</li>
            <li>• Only you have the encryption key - we cannot read your notes</li>
            <li>• Notes remain encrypted in our database at all times</li>
            <li>• This ensures maximum privacy and confidentiality for your therapy sessions</li>
          </ul>
        </div>
      </main>
    </div>
  );
}
